module.exports = __webpack_public_path__ + "img/jorify_1.e1a24c8e.svg";